import { Link } from '@backstage/core-components';
import { IconComponent } from '@backstage/core-plugin-api';
import {
  Box,
  createStyles,
  ImageList,
  ImageListItem,
  makeStyles,
  Typography,
} from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';
import { CustomViewComponent } from '../CustomView';
import { CustomViewRegister } from '../CustomView/registry';
import { WbFieldLabel } from '../WbFieldLabel';
import { CustomViewGridElement } from './utility';
import { WbEntityRefLinks } from '../WbEntityRefLink';

const useStyles = makeStyles(theme =>
  createStyles({
    link: { ...theme.typography.body1 },
    label: {
      color: theme.palette.text.secondary,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      lineHeight: '14px',
    },
    svgIcon: {
      display: 'inline-block',
      '& svg': {
        display: 'inline-block',
        fontSize: 'inherit',
        verticalAlign: 'baseline',
      },
    },
  }),
);

CustomViewRegister.register({
  id: 'link',
  function: function LinkView(props: Record<string, any>) {
    const classes = useStyles();
    let values = props.value;
    if (!Array.isArray(values)) {
      values = [values];
    }

    if (values.length === 0 && props.default) {
      return (
        <CustomViewComponent
          __disableNunjucksProcessing
          type="string"
          value={props.default}
          label={props.label ?? ''}
          colSpan={props.colSpan ?? '1'}
        />
      );
    }
    switch (props.mode) {
      case 'linear':
      case 'table':
        return (
          <WbEntityRefLinks
            entityRefs={values}
            defaultKind={props.kind}
            className={classes.link}
          />
        );
      default:
    }
    return (
      <CustomViewGridElement colSpan={props.colSpan}>
        <WbFieldLabel label={props.label} />
        <WbEntityRefLinks
          entityRefs={values}
          defaultKind={props.kind}
          className={classes.link}
        />
      </CustomViewGridElement>
    );
  },
});

function IconLink(props: {
  href: string;
  text?: string;
  Icon?: IconComponent;
}) {
  const { href, text, Icon } = props;
  const classes = useStyles();

  return (
    <Box display="flex">
      <Box mr={1} className={classes.svgIcon}>
        <Typography component="div">
          {Icon ? <Icon /> : <LanguageIcon />}
        </Typography>
      </Box>
      <Box flexGrow="1">
        <Link to={href} target="_blank" rel="noopener">
          {text || href}
        </Link>
      </Box>
    </Box>
  );
}

interface LinksGridListItem {
  href: string;
  text?: string;
  Icon?: IconComponent;
}
CustomViewRegister.register({
  id: 'link_grid_list',
  function: function LinkListView(props: Record<string, any>) {
    const list: LinksGridListItem[] = props.value;
    return (
      <ImageList rowHeight="auto" cols={1}>
        {list.map(({ text, href, Icon }, i) => (
          <ImageListItem key={i}>
            <IconLink href={href} text={text ?? href} Icon={Icon} />
          </ImageListItem>
        ))}
      </ImageList>
    );
  },
});
